.x{justify-content:center;}